(() => {
  const createVideo = (host) => {
    const video = document.createElement('video');
    const source = document.createElement('source');

    video.controls = true;
    video.playsInline = true;
    video.preload = 'metadata';
    video.poster = host.dataset.videoPoster;
    video.setAttribute('controlsList', 'nodownload');
    video.setAttribute('aria-label', 'Inside Lockey Safety Products company film');

    source.src = host.dataset.videoSrc;
    source.type = 'video/mp4';
    video.append(source);
    return video;
  };

  document.querySelectorAll('[data-factory-gallery]').forEach((gallery) => {
    const stage = gallery.querySelector('[data-factory-stage]');
    const items = Array.from(gallery.querySelectorAll('[data-factory-item]'));
    const current = gallery.querySelector('[data-factory-current]');
    const progress = gallery.querySelector('[data-factory-progress]');
    const prev = gallery.querySelector('[data-factory-prev]');
    const next = gallery.querySelector('[data-factory-next]');
    const trigger = gallery.querySelector('[data-factory-video]');
    const dialog = gallery.querySelector('[data-factory-dialog]');
    const close = gallery.querySelector('[data-factory-close]');
    const videoHost = gallery.querySelector('[data-factory-video-host]');
    let activeIndex = 0;

    const activate = (index, shouldScroll = false) => {
      activeIndex = (index + items.length) % items.length;
      const active = items[activeIndex];
      const key = active.dataset.factoryItem;

      stage.dataset.active = key;
      gallery.dataset.active = key;
      items.forEach((item, itemIndex) => {
        const selected = itemIndex === activeIndex;
        item.classList.toggle('is-active', selected);
        item.setAttribute('aria-pressed', String(selected));
      });

      if (current) current.textContent = String(activeIndex + 1).padStart(2, '0');
      if (progress) progress.style.transform = `translateX(${activeIndex * 100}%)`;
      if (shouldScroll && window.matchMedia('(max-width: 56rem)').matches) {
        active.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' });
      }
    };

    items.forEach((item, index) => {
      item.addEventListener('click', () => activate(index, true));
      item.addEventListener('focus', () => activate(index));
      if (window.matchMedia('(hover: hover) and (pointer: fine)').matches) {
        item.addEventListener('pointerenter', () => activate(index));
      }
    });

    prev?.addEventListener('click', () => activate(activeIndex - 1, true));
    next?.addEventListener('click', () => activate(activeIndex + 1, true));

    stage?.addEventListener('keydown', (event) => {
      if (event.key === 'ArrowLeft') {
        event.preventDefault();
        activate(activeIndex - 1, true);
        items[activeIndex].focus();
      }
      if (event.key === 'ArrowRight') {
        event.preventDefault();
        activate(activeIndex + 1, true);
        items[activeIndex].focus();
      }
    });

    const closeVideo = () => {
      if (dialog?.open) dialog.close();
      if (videoHost) videoHost.replaceChildren();
      trigger?.setAttribute('aria-expanded', 'false');
    };

    trigger?.addEventListener('click', () => {
      if (!dialog || !videoHost) return;
      const video = createVideo(videoHost);
      videoHost.replaceChildren(video);
      trigger.setAttribute('aria-expanded', 'true');
      dialog.showModal();
      video.play().catch(() => {});
    });

    close?.addEventListener('click', closeVideo);
    dialog?.addEventListener('close', () => {
      const video = videoHost?.querySelector('video');
      video?.pause();
      if (videoHost) videoHost.replaceChildren();
      trigger?.setAttribute('aria-expanded', 'false');
    });
    dialog?.addEventListener('click', (event) => {
      if (event.target === dialog) closeVideo();
    });

    activate(0);
  });
})();
